import { put, takeLatest, select, cancel } from 'redux-saga/effects';
import { merge } from 'lodash';

import {
  paginatedConsts as answeredSurveysPaginatedConsts,
  paginatedActions as answeredSurveysPaginatedActions,
} from '../answered';
import {
  selectAnsweredList,
  selectAnsweredListCounter,
  selectAnsweredPagination,
} from '../selectors';

function* answeredSurveysPaginationWorker({ payload: { limit, id } = {} }) {
  const paginationOptions = yield select(selectAnsweredPagination);
  const requestsTotal = yield select(selectAnsweredListCounter);
  const existingRequests = yield select(selectAnsweredList);

  if (requestsTotal <= existingRequests.length) {
    yield cancel();
  }

  const params = merge({}, paginationOptions, {
    offset: existingRequests.length,
    limit,
    id,
  });

  yield put(answeredSurveysPaginatedActions.updatePaginationParameters(params));

  yield put({
    type: answeredSurveysPaginatedConsts.SEND,
    payload: params,
  });
}

export default function* answeredSurveysPaginationSaga() {
  yield takeLatest(
    answeredSurveysPaginatedConsts.LOAD_NEXT_REQUESTS,
    answeredSurveysPaginationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/surveys/sagas/answered-surveys-pagination-saga.js